<template>
  <a :href="isLink && linkUrl" target="_blank" rel="noopener noreferrer" @click="onClick()">
    <div
      class="flex flex-row pl-4 pr-2 py-4 text-black bg-white rounded shadow cursor-pointer hover:text-black"
    >
      <div
        class="flex flex-col items-center justify-center w-12 h-12 bg-blue-300 rounded-full link-icon"
      >
        <i
          class="ds-text-2xl text-white bg-white bg-blue-300 sr-2"
          :class="{ 'sr-v2-file-acrobat': isPdf, 'sr-v2-link': !isPdf && !isFile, 'sr-v2-file': isFile }"
        />
      </div>
      <div class="flex flex-col justify-center w-full max-w-full px-2 truncate">
        <p class="font-normal truncate">{{title}}</p>
      </div>
      <div class="flex flex-col justify-center">
        <Button icon="sr-2 sr-v2-arrow-right" emphasis="low" color="blue" />
        <!-- <i class="ds-text-2xl text-blue-300 sr-2 sr-v2-arrow-right" /> -->
      </div>
    </div>
  </a>
</template>

<script>
import { mapActions } from "vuex";
import { createDocumentView } from "@/services/viewTracker";
import { Button } from '@sportsrecruits/playbook';
export default {
  props: {
    document: { type: Object, required: true }
  },
  components: {
    Button
  },
  computed: {
    title() {
      return this.document.name || this.document.filename;
    },
    isPdf() {
      return /\.pdf$/i.test(this.document.filename);
    },
    isFile() {
      return this.document.isHosted && !this.isPdf;
    },

    isHosted() {
      return this.document.isHosted;
    },

    isLink() {
      return !this.isHosted;
    },

    linkUrl() {
      return this.document.url;
    }
  },

  methods: {
    ...mapActions("athleteProfile", ["downloadDocument"]),

    onClick() {
      createDocumentView({ resource_id: this.document.id });

      if (this.isHosted) {
        this.downloadDocument(this.document);
      }
    }
  }
};
</script>

<style scoped>
.link-icon {
  min-width: 3rem;
}
</style>